import { Form, Input, Select, Button } from "antd";
import { DatePicker } from "tncet-common";
import { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import TnMessage from "../message";
import { createProject } from "@/api/project-manage/project";
import MonixModal from "../monix-modal";
import { MonitorTypeList } from "@/enums/monitor-type";
import { getUsers } from "@/api/lib/user";
import { User } from "@/global/interface/project-manage/user";

interface IProps {
    showModal: boolean
    setShowModal: (v: boolean) => void
    onSuccess: () => void
}

export default function CreateProjectModal(props: IProps) {
    const [form] = Form.useForm();
    const btnRef = useRef(null);
    const [users, setUsers] = useState<User[]>([]);

    useEffect(() => {
        getUsers().then(res => {
            if (res.status === 200) {
                let users: User[] = res.data || [];
                setUsers(users);
            }
        })
    }, [])

    const onCreateProject = () => {
        if (btnRef.current) {
            btnRef.current.click();
        }
    }

    const onFinish = (value) => {
        value = {
            ...value,
            startTime: dayjs(value.startTime).valueOf()
        }
        // setLoading(true)
        createProject(value).then(res => {
            if (res.status === 200) {
                // generateData();
                TnMessage.success("创建成功");
                // setShowModal(false);
                props.onSuccess();
            }
        }).catch(err => {
            TnMessage.error("创建失败");
        }).finally(() => {
            // setLoading(false);
        })
    }

    return (
        <MonixModal
            title={"创建项目"}
            visible={props.showModal}
            setVisible={(e) => props.setShowModal(e)}
            onSaveClick={onCreateProject}
            wrapClassName="create-project-modal"
        >
            <div className="create-project-body">
                <Form
                    colon={false}
                    form={form}
                    autoComplete="off"
                    labelCol={{ span: 6 }}
                    onFinish={onFinish}
                >
                    <Form.Item label="项目名称:" name="name" rules={[{ required: true, message: '项目名称不能为空' }]} >
                        <Input autoFocus />
                    </Form.Item>
                    <Form.Item label="监测等级:" name="monitorRank" rules={[{ required: true, message: '监测等级不能为空' }]} >
                        <Select>
                            <Select.Option value={1}>一级</Select.Option>
                            <Select.Option value={2}>二级</Select.Option>
                            <Select.Option value={3}>三级</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="监测类别:" name="monitorType" rules={[{ required: true, message: '监测类别不能为空' }]} >
                        <Select>
                            {MonitorTypeList.map((item, idx) => (
                                <Select.Option value={item.value} key={idx}>{item.label}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="开始时间:" name="startTime" rules={[{ required: true, message: '开始时间不能为空' }]} >
                        <DatePicker
                            style={{ width: '100%' }}
                            placeholder=""
                        />
                    </Form.Item>
                    <Form.Item label="监测周期(天):" name="period" rules={[{ required: true, message: '监测周期不能为空' }]} >
                        <Input />
                    </Form.Item>
                    <Form.Item label="负责人:" name="leaderId">
                        <Select>
                            {users?.map((item, key) => (
                                <Select.Option key={key} value={item?.id}>{item?.name || ''}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Button ref={btnRef} htmlType="submit" style={{ display: 'none' }}></Button>
                </Form>
            </div>
        </MonixModal>
    )
}